export enum ContactType {

  COMPANY = 'COMPANY',
  PERSON = 'PERSON',
  COMPANY_CONTACT = 'COMPANY_CONTACT'
}
